import React, { useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const threshold = window.innerHeight * 1.8;
      if (window.scrollY > threshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    const handleScrollToTopStart = () => {
      setIsVisible(false);
    };

    window.addEventListener("scroll-to-top-start", handleScrollToTopStart);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll-to-top-start", handleScrollToTopStart);
    };
  }, []);

  const handleScrollTop = () => {
    window.dispatchEvent(new CustomEvent("scroll-to-top-start"));
    if (window.lenis) {
      window.lenis.scrollTo(0, { duration: 1.5 });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <button
      type="button"
      onClick={handleScrollTop}
      className="fixed right-6 bottom-6 z-[90] font-mono text-[0.7rem] uppercase tracking-[0.2em] px-3.5 py-2 rounded-full border backdrop-blur-md transition-all duration-500 hover:scale-105 active:scale-95 cursor-pointer flex items-center gap-1.5"
      style={{
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        transform: `translateY(${isVisible ? "0" : "15px"})`,
        background: "var(--paper-2)",
        borderColor: "var(--rule)",
        color: "var(--ink)",
        boxShadow: "0 4px 18px 0 rgba(0, 0, 0, 0.05)",
      }}
    >
      <span>AKKI</span>
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(-90deg)" }}>
        <path d="M1 5h8m0 0L5 1m4 4L5 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
};

export default BackToTop;
